/**
 * Enumeration of possible Authentication Command Types
 */
export class AuthenticationCommands{
    static CheckAuthentication = "check-authentication";
    static ChangePassword = "change-password";
    static Initialize = "initialize";
    static Logout = "logout";
    static RedeemCode = "redeem-code";
    static RefreshTokens = "refresh-tokens";
    static UpdateProfile = "update-profile";
}
